// @flow

import help from 'app/get-help/components/blocks/Help';
import radio from 'app/get-help/components/blocks/Radio';
import {
  createMediaField,
  getUserFields,
  messageField,
} from 'app/get-help/content/nodes/common';
import { ZENDESK_CUSTOM_FIELD_IDS } from 'app/get-help/constants';


const createBugOrFeatureRequestChildren = (isLoggedIn: boolean) => {
  const reportABugFields = [
    ...getUserFields(isLoggedIn),
    {
      ...messageField,
      label: `Please tell us a little more so we can help you quicker.`,
      details: `Please provide a detailed description of the problem you encountered, including any error messages or unexpected behavior you observed.`,
    },
    createMediaField(),
  ];

  const requestAFeatureFields = [
    ...getUserFields(isLoggedIn),
    {
      ...messageField,
      label: `Request a feature`,
      details: `Describe the feature you'd like, and specify whether it's an app feature or a general Zapier feature. Include use cases where you would find this feature useful.`,
    },
    createMediaField(),
  ];

  return radio({
    id: 'problem',
    label: 'What can we help you with?',
    zendeskCustomFieldId: ZENDESK_CUSTOM_FIELD_IDS.REPORT_BUG_OR_REQUEST_FEATURE,
    items: [
      {
        value: 'reportABug',
        label: 'Report a bug',
        zendeskCustomFieldValue: 'cf-report-bug',
        child: help({
          contact: reportABugFields,
        }),
      },
      {
        value: 'requestAFeature',
        label: 'Request a feature',
        zendeskCustomFieldValue: 'cf-request-feature',
        child: help({
          contact: requestAFeatureFields,
        }),
      },
    ],
  });
};

export default createBugOrFeatureRequestChildren;
